export class GetTableDataQualityQuarantineResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "summary",
            "baseName": "summary",
            "type": "QuarantineSummary",
            "format": ""
        },
        {
            "name": "batches",
            "baseName": "batches",
            "type": "Array<QuarantineBatch>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableDataQualityQuarantineResponse.attributeTypeMap;
    }
    constructor() {
    }
}
